<!--CONTRATO DE APERTURA DE CRÉDITO (TARJETA AMERICAN EXPRESS) - PERSONA FISICA-->
<template>
    <div class="page-simulator">
        <form class="form-inline contract-container single-page-mode" @submit.prevent="handleSubmit">
            <div class="content-ref" ref="contractContent">

                <!-- Page 1 -->
                <div class="paper-sheet">
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <div class="main-content">
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number">
                                            Número de Contrato: <input type="text" class="underline-input"
                                                :value="store.formSaveCOAS.referenceNumber || ''" disabled />
                                        </div>
                                        <div class="contract-title text-uppercase">
                                            <p>
                                                <strong>CONTRATO DE APERTURA DE CRÉDITO</strong>, CUYO NÚMERO DE
                                                IDENTIFICACIÓN SE INDICA EN LA CARÁTULA BAJO EL RUBRO
                                                "NÚMERO DE CONTRATO", QUE CELEBRAN POR UNA PARTE LA SOCIEDAD <strong>KVF
                                                    GROUP, S.A. DE C.V.</strong>, RECONOCIDA COMO
                                                EL ACREDITANTE, A QUIEN EN LO SUCESIVO SE LE DENOMINARÁ COMO
                                                <strong>"GOLDBERGFUND"</strong>, Y POR OTRA PARTE LA
                                                PERSONA FÍSICA CUYO NOMBRE SE INDICA EN LA CARÁTULA DEL PRESENTE
                                                CONTRATO,
                                                RECONOCIDA COMO EL
                                                ACREDITADO, EN LO SUCESIVO <strong>"EL ACREDITADO"</strong>, Y LA
                                                PERSONA
                                                MORAL O FÍSICA CUYA DENOMINACIÓN, RAZÓN SOCIAL O
                                                NOMBRE RESPECTIVAMENTE, SE INDICAN EN LA CARÁTULA DEL PRESENTE CONTRATO,
                                                RECONOCIDO COMO EL OBLIGADO
                                                SOLIDARIO, EN LO SUCESIVO <strong>"EL OBLIGADO SOLIDARIO"</strong>,
                                                QUIENES
                                                SE SUJETAN AL TENOR DE LAS SIGUIENTES
                                                DECLARACIONES Y CLÁUSULAS:
                                            </p>
                                        </div>
                                    </div>

                                    <div class="section-title text-uppercase">DECLARACIONES:</div>
                                    <div class="title-clausula-exception">
                                        <strong>
                                            I.- Declara GOLDBERGFUND, por conducto de su representante legal, y bajo
                                            protesta de decir verdad que:
                                        </strong>
                                    </div>
                                    <div class="declaration-item">
                                        <strong>a)</strong> Que está legalmente constituida conforme a las leyes
                                        mexicanas
                                        según consta en la Escritura Pública número 235
                                        con fecha diez de febrero de dos mil dieciséis, pasada ante la fe del Lic.
                                        Gabriela
                                        Alejandra González López, Notario
                                        Público número 82 en el Estado de Quintana Roo;
                                    </div>
                                    <div class="declaration-item">
                                        <strong>b)</strong> Que su representada le otorgó facultades suficientes para
                                        comparecer a la celebración del presente contrato,
                                        mismas que a la fecha no le han sido revocadas, modificadas o restringidas de
                                        forma
                                        alguna.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>c)</strong> Para todos los efectos del presente contrato, señala como
                                        domicilio para oír y recibir notificaciones el ubicado en
                                        Calle Robert Schumann, Número 4898, Colonia Lomas del Seminario, Zapopan,
                                        Jalisco,
                                        C.P 45038.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>d)</strong> Que es su deseo celebrar el presente contrato con <strong>EL
                                            ACREDITADO</strong> y el <strong>OBLIGADO SOLIDARIO</strong> en virtud de
                                        contar
                                        con la capacidad y experiencia necesaria para el cumplimiento del presente
                                        contrato
                                        en los términos y condiciones que
                                        más adelante se indican.
                                    </div>

                                    <div class="title-clausula">
                                        <strong>
                                            II.- Declara EL ACREDITADO, por su propio y personal derecho, y bajo
                                            protesta de
                                            decir verdad que:
                                        </strong>
                                    </div>
                                    <div class="declaration-item">
                                        <strong>a)</strong> Es una persona física, mayor de edad, con plena capacidad
                                        para
                                        contratar y obligarse con los términos de este
                                        contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>b)</strong> Que tanto la información y los datos generales
                                        proporcionados en
                                        la carátula del presente contrato (Anexo A) y
                                        consignada como los datos patrimoniales que ha entregado con anterioridad a
                                        <strong>GOLDBERGFUND</strong> son verdaderos, y que
                                        presentan de manera exacta y fiel su situación financiera al momento de la firma
                                        del
                                        presente contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>c)</strong> Para todos los efectos del presente contrato, señala como
                                        domicilio para oír y recibir notificaciones el señalado en
                                        la carátula de este contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>d)</strong> Tener la debida capacidad jurídica y económica para
                                        contratar y
                                        obligarse en los términos del presente contrato, no
                                        se tiene ninguna limitación legal, contractual, de alguna autoridad judicial o
                                        administrativa, o de cualquier otra índole
                                        para celebrar el presente contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>e)</strong> Los recursos que utilizará para pagar las obligaciones
                                        derivadas
                                        del presente contra no son, ni serán de procedencia
                                        ilícita.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>f)</strong> Es su voluntad celebrar el presente contrato, en los
                                        términos y
                                        bajo las condiciones que el mismo establece.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>g)</strong> Que <strong>GOLDBERGFUND</strong> le hizo del conocimiento
                                        antes
                                        de la firma de este contrato: Su contenido, tasa de interés
                                        ordinario, moratorio, comisiones, seguros o gastos que se generarán por la
                                        celebración del presente contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>h)</strong> Que <strong>GOLDBERGFUND</strong> le explico el CAT
                                        reflejado en
                                        la carátula del contrato.
                                    </div>

                                    <div class="title-clausula">
                                        <strong>
                                            III.- Declara EL OBLIGADO SOLIDARIO, bajo protesta de decir verdad que:
                                        </strong>
                                    </div>
                                    <div class="declaration-item">
                                        <strong>a)</strong> Los datos generales son y corresponden a los que han quedado
                                        señalados en la carátula del presente, la cual es
                                        presentada como Anexo A y en los formatos de identificación establecidos por
                                        <strong>GOLDBERGFUND</strong> es: (i) una persona
                                        física, mayor de edad con plena capacidad para contratar y obligarse con los
                                        términos de este contrato, o (ii) una
                                        persona moral debidamente constituida y existente conforme a las leyes de México
                                        y
                                        que su representante en este
                                        acto cuenta con las facultades suficientes para contratar y obligar a su
                                        representada en los términos de este contrato,
                                        mismas facultades que a la fecha no le han sido modificadas, limitadas o
                                        revocadas
                                        en forma alguna, encontrándose
                                        debidamente inscritas en el Registro Público de la Propiedad y de Comercio.
                                    </div>
                                </div>
                            </slot>
                        </div>
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 2 -->
                <div class="paper-sheet">
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <div class="main-content">
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number">
                                            Número de Contrato: <input type="text" class="underline-input"
                                                :value="store.formSaveCOAS.referenceNumber || ''" disabled />
                                        </div>
                                    </div>
                                    <div class="declaration-item">
                                        <strong>b)</strong> Que tanto la información proporcionada en la carátula del
                                        presente contrato (Anexo A) y consignada como los datos
                                        patrimoniales que ha entregado con anterioridad a <strong>GOLDBERGFUND</strong>
                                        son
                                        verdaderos, que presentan de manera exacta
                                        y fiel su situación financiera al momento de la firma del presente contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>c)</strong> Tener la debida capacidad jurídica y económica para
                                        contratar y
                                        obligarse en los términos del presente contrato, no
                                        se tiene ninguna limitación legal, contractual, de alguna autoridad judicial o
                                        administrativa, o de cualquier otra índole
                                        para celebrar el presente contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>d)</strong> Los recursos que utilizarán para pagar las obligaciones
                                        derivadas del presente contrato no son ni serán de
                                        procedencia ilícita.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>e)</strong> Es su voluntad celebrar el presente contrato y constituirse
                                        como
                                        <strong>OBLIGADO SOLIDARIO</strong>, y, en consecuencia, obligarse
                                        con <strong>GOLDBERGFUND</strong> respecto del cumplimiento de todas y cada una
                                        de
                                        las obligaciones a cargo de <strong>EL ACREDITADO</strong>,
                                        de conformidad a los términos y condiciones del presente contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>f)</strong> Manifiesta que, previamente a la celebración del presente
                                        contrato <strong>GOLDBERGFUND</strong> le informó las obligaciones que
                                        asume por comparecer con el carácter de <strong>OBLIGADO SOLIDARIO</strong> a la
                                        celebración del presente contrato, enfatizando
                                        que, <strong>GOLDBERGFUND</strong> podrá, exigirle directamente el cumplimiento
                                        de
                                        las obligaciones derivadas del presente
                                        contrato, sin necesidad de agotar el cobro primeramente a <strong>EL
                                            ACREDITADO.</strong>
                                    </div>

                                    <div class="title-clausula-list">
                                        <strong>
                                            IV.- Declaran GOLDBERGFUND, EL ACREDITADO y EL OBLIGADO SOLIDARIO, bajo
                                            protesta
                                            de decir verdad:
                                        </strong>
                                    </div>
                                    <div class="list-declaration">
                                        <ol type="a" class="list-text custom-alpha">
                                            <li class="list-letter">
                                                <span class="list-title">Que para efectos del presente contrato acuerdan
                                                    las
                                                    siguientes definiciones:</span>

                                                <ol class="custom-number">
                                                    <li class="sublist-number">
                                                        <strong>Contrato:</strong> Documento presente por medio del cual
                                                        se
                                                        establecen los términos y condiciones a las que se obligan
                                                        las partes, que en conjunto con la carátula y anexos forman un
                                                        mismo
                                                        documento.
                                                    </li>
                                                    <li>
                                                        <strong>Carátula:</strong> Documento que forma parte integrante
                                                        de
                                                        este contrato como el Anexo “A”, en lo sucesivo la carátula,
                                                        donde se expresan los datos generales de <strong>EL ACREDITADO,
                                                            GOLDBERGFUND, OBLIGADO SOLIDARIO,</strong> así como
                                                        las características que rigen al presente contrato.
                                                    </li>
                                                    <li>
                                                        <strong>Obligado Solidario:</strong> Persona Física o Moral, que
                                                        se
                                                        obliga mediante su firma a liquidar las obligaciones de pago
                                                        derivadas del presente contrato en caso de incumplimiento de
                                                        <strong>EL ACREDITADO</strong>, o bien en caso de que
                                                        <strong>GOLDBERGFUND</strong> estime de buena fe que hay riesgo
                                                        que
                                                        <strong>EL ACREDITADO</strong> no liquide las obligaciones de
                                                        pago,
                                                        debido a que incumpla con una o más obligaciones del presente
                                                        contrato, o bien porque cambien las
                                                        circunstancias bajo las cuales firma el contrato <strong>EL
                                                            ACREDITADO.</strong>
                                                    </li>
                                                    <li>
                                                        <strong>Interés Ordinario:</strong> Cantidad expresada en
                                                        términos
                                                        porcentuales anuales, que <strong>EL ACREDITADO</strong>, o en
                                                        su
                                                        caso
                                                        <strong>EL OBLIGADO SOLIDARIO</strong> está obligado a pagar a
                                                        <strong>GOLDBERGFUD</strong>, por poner a disposición del
                                                        <strong>ACREDITADO</strong> un monto en pesos.
                                                    </li>
                                                    <li>
                                                        <strong>Interés Moratorio:</strong> Cantidad expresada en
                                                        términos
                                                        porcentuales que <strong>EL ACREDITADO</strong>, o en su caso
                                                        <strong>EL OBLIGADO
                                                            SOLIDARIO</strong>, está obligado a pagar a
                                                        <strong>GOLDBERGFUD</strong> por el pago tardío.
                                                    </li>
                                                    <li>
                                                        <strong>CAT:</strong> Costo total del financiamiento del
                                                        presente
                                                        contrato, expresado en términos porcentuales anuales, para
                                                        fines informativos y de comparación, incorpora la totalidad de
                                                        los
                                                        costos y gastos inherentes a este contrato.
                                                    </li>
                                                    <li>
                                                        <strong>Seguros:</strong> Coberturas que <strong>EL
                                                            ACREDITADO</strong> está obligado a contratar por medio de
                                                        <strong>GOLDBERGFUND</strong>, para amparar
                                                        un siniestro.
                                                    </li>
                                                    <li>
                                                        <strong>Pago Anticipado:</strong> Pago parcial o total del saldo
                                                        insoluto de un contrato, antes de la fecha en que sea exigible.
                                                    </li>
                                                    <li>
                                                        <strong>LFPDPPP:</strong> Ley Federal de Protección de Datos
                                                        Personales en Posesión de Particulares.
                                                    </li>
                                                    <li>
                                                        <strong>Pagaré:</strong> Documento mercantil que garantiza el
                                                        cumplimiento de las obligaciones derivadas de la firma de este
                                                        contrato y forma parte integrante como <strong>Anexo
                                                            “C”</strong>
                                                    </li>
                                                    <li>
                                                        <strong>American Express:</strong> Compañía global de servicios
                                                        integrados de viajes y financiero, principalmente en la emisión
                                                        y
                                                        comercialización de tarjetas de crédito.
                                                    </li>
                                                    <li>
                                                        <strong>Tarjeta de Crédito Adicional:</strong> Línea de crédito
                                                        puesta a disposición del <strong>EL ACREDITADO</strong>
                                                        mediante un plástico emitido y comercializado por American
                                                        Express.
                                                    </li>
                                                    <li>
                                                        <strong>Disposición de Recursos:</strong> Importe en pesos que
                                                        <strong>GOLDBERGFUND</strong> autoriza le sea entregado mediante
                                                        transferencia electrónica o cheque nominativo a <strong>EL
                                                            ACREDITADO</strong>.
                                                    </li>
                                                    <li>
                                                        <strong>Día Hábil:</strong> Días dispuestos por la Comisión
                                                        Nacional
                                                        Bancaria y de Valores para que las instituciones de crédito
                                                        presten los servicios al público.
                                                    </li>
                                                    <li>
                                                        <strong>Entidad Financiera:</strong> Aquella agrupación que se
                                                        dedica a ofrecer servicios financieros. Esta realiza actividades
                                                        bancarias de intermediación financiera, seguros, inversión en
                                                        valores otros.
                                                    </li>
                                                </ol>
                                            </li>
                                            <li class="list-letter">
                                                <span class="list-title">Que se reconocen mutuamente la personalidad con
                                                    la
                                                    que actúan.</span>
                                            </li>
                                            <li class="list-letter">
                                                <span class="list-title">Que conocen el contenido y alcance legal del
                                                    presente contrato manifestándose conformes con los derechos y
                                                    obligaciones incluidos y asumidos en el mismo.</span>
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </slot>
                        </div>
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 3 -->
                <div class="paper-sheet">
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <div class="main-content">
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number">
                                            Número de Contrato: <input type="text" class="underline-input"
                                                :value="store.formSaveCOAS.referenceNumber || ''" disabled />
                                        </div>
                                    </div>
                                    <div class="list-declaration">
                                        <ol type="d" class="list-text custom-alpha custom-alpha-position">
                                            <li class="list-letter">
                                                <span class="list-title">Que comparecen libremente a la firma del
                                                    presente
                                                    contrato sin vicios de la voluntad renunciando por tanto a la
                                                    interposición de cualquier acción fundamentada en vicios del
                                                    consentimiento.</span>
                                            </li>
                                        </ol>
                                    </div>
                                    <div class="mt-3">
                                        <strong>
                                            Estando de acuerdo con las Declaraciones que anteceden GOLDBERGFUND, EL
                                            ACREDITADO Y
                                            EL OBLIGADO SOLIDARIO
                                            convienen en sujetarse al tenor de las siguientes:
                                        </strong>
                                    </div>

                                    <div class="section-title text-uppercase">CLÁUSULAS:</div>

                                    <div class="content-clausulas">
                                        <p>
                                            <strong>PRIMERA. ‐ GOLDBERGFUND</strong> pone a disposición de <strong>EL
                                                ACREDITADO</strong> el importe establecido en la carátula del presente
                                            contrato, misma que corresponde al Anexo A, mediante una Tarjeta de Crédito
                                            adicional emitida y comercializada por la
                                            institución financiera denominada American Express (en delante “American
                                            Express”), en cuyo monto no quedan
                                            comprendidos los intereses ordinarios, moratorios, seguros, comisiones,
                                            impuestos al valor agregado, y en general ningún
                                            gasto que se cause en virtud de la firma de este contrato, los cuales
                                            deberán
                                            ser cubiertos por <strong>EL ACREDITADO</strong> en las
                                            Fechas de Pago mencionadas en Anexo B del presente contrato.
                                        </p>
                                        <p>
                                            <strong>SEGUNDA. ‐</strong> El importe mencionado en la caratula (Anexo A)
                                            del
                                            presente contrato, formará parte de una línea revolvente
                                            mediante una tarjeta de crédito adicional emitida y comercializada por
                                            <i>“American Express”</i>, mediante la cual, <strong>EL
                                                ACREDITADO</strong> podrá disponer del saldo asignado a la tarjeta para
                                            realizar compras en los establecimientos autorizados por
                                            <i>“American Express”</i> en el territorio nacional o extranjero.
                                        </p>
                                        <p>
                                            Cada compra disminuirá el importe del crédito revolvente mencionado en la
                                            caratula (Anexo A) de este contrato. <strong>EL
                                                ACREDITADO</strong> se obliga a liquidar a <strong>GOLDBERGFUND</strong>
                                            las
                                            compras realizadas conforme a la CLÁUSULA SEXTA del presente
                                            contrato en las fechas límite establecidas en el Anexo B o en el estado de
                                            cuenta correspondiente, misma que le será
                                            proporcionado a EL ACREDITADO a través de su correo electrónico y que deberá
                                            liquidar el saldo dentro de los 3 días
                                            hábiles siguientes a las fechas de corte.
                                        </p>
                                        <p>
                                            <strong>TERCERA. ‐</strong> Dentro de los 10 (diez) días hábiles siguientes
                                            a la
                                            fecha de celebración de este contrato, <strong> EL ACREDITADO</strong>
                                            tendrá
                                            derecho a cancelar el presente contrato sin responsabilidad alguna para él,
                                            siempre y cuando: (i) <strong>EL ACREDITADO</strong> notifique
                                            por escrito a <strong>GOLDBERGFUND</strong> dentro de dicho plazo, su deseo
                                            de
                                            cancelar este contrato; y (ii) <strong>EL ACREDITADO</strong> no haya
                                            realizado la activación y/o compras con la tarjeta de crédito adicional
                                            asignada.
                                        </p>
                                        <p>
                                            <strong>CUARTA. ‐ EL ACREDITADO</strong> se obliga a contratar un seguro de
                                            vida
                                            y uno de desempleo con la compañía de seguros y
                                            características especificadas en la carátula del presente contrato, misma
                                            que
                                            corresponde al <strong>Anexo A.</strong> El seguro
                                            permanecerá vigente hasta la fecha de terminación del contrato.
                                        </p>
                                        <p>
                                            <strong>GOLDBERGFUND</strong> gestionará la contratación del seguro de vida
                                            y
                                            desempleo con un tercero independiente, entregando
                                            dos ejemplares de la póliza de seguro, uno para
                                            <strong>GOLDBERGFUND</strong> y
                                            otro para <strong>EL ACREDITADO</strong>, la póliza deberá contener:
                                            (i) La vigencia de los seguros por un plazo no menor al del presente
                                            contrato,
                                            (ii) El endoso de beneficiario preferente en
                                            favor de <strong>GOLDBERGFUND</strong>, y (iii) La aceptación por parte de
                                            la
                                            aseguradora que tanto la póliza como el endoso, no podrán
                                            ser cancelados, modificados, revocados o terminados, sin la autorización
                                            previa
                                            y por escrito de <strong>GOLDBERGFUND</strong>..
                                        </p>
                                        <p>
                                            El pago parcial de las primas de seguros contratadas por <strong>EL
                                                ACREDITADO</strong>, se verán reflejados en los estados de cuenta
                                            emitidos por <strong>GOLDBERGFUND</strong> y enviados a <stron>EL ACREDITADO
                                            </stron> de forma mensual.
                                        </p>
                                        <p>
                                            <strong>QUINTA. ‐ EL ACREDITADO</strong> pagará a
                                            <strong>GOLDBERGFUND</strong>
                                            por concepto de manejo de cuenta una comisión mensual, la cual se
                                            calculará multiplicando el límite de crédito asignado a la tarjeta de
                                            crédito
                                            adicional por un porcentaje mensual, mismo
                                            que se estipula en la carátula (Anexo A) del presente contrato.
                                        </p>
                                        <p>
                                            El pago mensual por manejo de cuenta se verá reflejado en el estado de
                                            cuenta
                                            emitido por <strong>GOLDBERGFUND</strong> y enviado a
                                            <strong>EL ACREDITADO</strong> de forma mensual.
                                        </p>
                                        <p>
                                            Adicionalmente <strong>EL ACREDITADO</strong> se obliga a pagar una comisión
                                            anual por la expedición de la tarjeta de crédito adicional
                                            emitida y comercializada por “American Express”, el pago se verá reflejado
                                            en el
                                            primer estado de cuenta expedido por
                                            <strong>GOLDBERGFUND</strong>, y cada año en la misma fecha, por el tiempo
                                            que
                                            esté vigente el presente contrato.
                                        </p>
                                    </div>
                                </div>
                            </slot>
                        </div>
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 4 -->
                <div class="paper-sheet">
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <div class="main-content">
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number">
                                            Número de Contrato: <input type="text" class="underline-input"
                                                :value="store.formSaveCOAS.referenceNumber || ''" disabled />
                                        </div>
                                    </div>
                                    <div class="content-clausulas">
                                        <p>
                                            <strong>SEXTA. - EL ACREDITADO</strong> se obliga a restituir de forma
                                            mensual a <strong>GOLDBERGFUND</strong> el monto de las compras realizadas,
                                            así
                                            como el interés ordinario, interés moratorio, seguros, comisiones y en
                                            general cualquier obligación de pago derivada del
                                            presente contrato, en las fechas establecidas en el Anexo B del presente
                                            contrato, los montos a pagar se darán a conocer
                                            por <strong>GOLDBERGFUND</strong> mensualmente conforme a las compras
                                            realizadas por <strong>EL ACREDITADO</strong>, los seguros y comisiones
                                            generadas, las cuales se reflejarán en el estado de cuenta.
                                        </p>
                                        <p>
                                            El pago que <strong>EL ACREDITADO</strong> deba hacer a favor de
                                            <strong>GOLDBERGFUND</strong>, lo hará sin necesidad de previo cobro, en
                                            pesos, en
                                            la fecha de su vencimiento, incluyendo sin limitación alguna los pagos de
                                            intereses, comisiones, y seguros, a través de
                                            depósito bancario en la institución, y número de cuenta señalados en la
                                            carátula del presente contrato.
                                        </p>
                                        <p>
                                            El pago se realizará en la fecha y por la cantidad indicada en el estado de
                                            cuenta del mes correspondiente. Cuando la fecha
                                            límite de pago sea en un día inhábil esta se recorrerá al siguiente día
                                            hábil, sin que proceda el cobro de comisiones o
                                            intereses moratorios.
                                        </p>
                                        <p>
                                            Sin perjuicio de lo anterior, <strong>EL ACREDITADO</strong> autoriza
                                            expresamente a <strong>GOLDBERGFUND</strong>, mediante la suscripción del
                                            formato
                                            de domiciliación de pago (Anexo D) que forma parte integrante de este
                                            contrato, para que cargue en la cuenta bancaria
                                            que <strong>EL ACREDITADO</strong> señale, la cantidad indicada como
                                            <strong><i>“Pago para no Generar Interés”</i></strong> y/o cualquier otro concepto
                                            que,
                                            con motivo de la falta de pago oportuno, se cause en términos del presente
                                            contrato, estos últimos en cualquier fecha,
                                            para lo cual autoriza a <strong>GOLDBERGFUND</strong> para que realice el
                                            cargo domiciliado a dicha cuenta.
                                        </p>
                                        <p>
                                            En todo momento <strong>EL ACREDITADO</strong> podrá solicitar la
                                            cancelación de la autorización otorgada en el párrafo que antecede
                                            por medio de la presente cláusula sin costo a su cargo, en cuyo caso deberá
                                            efectuar el pago en términos del tercer párrafo
                                            de esta cláusula.
                                        </p>
                                        <p>
                                            En caso de que <strong>EL ACREDITADO</strong> tuviese alguna duda o requiera
                                            aclaración respecto de las cantidades reportadas como
                                            saldos pendientes, los intereses cobrados o en general una diferencia en
                                            relación con la información proporcionada
                                            respecto de su crédito, podrá presentar su solicitud de aclaración, la cual
                                            deberá ser resuelta por <strong>GOLDBERGFUND</strong> dentro
                                            de un plazo máximo 30 días hábiles posteriores a que se haya solicitado
                                            dicha aclaración. En caso de que <strong>GOLDBERGFUND</strong>
                                            no dé respuesta dentro del plazo mencionado, se entenderá que los saldos
                                            pendientes, intereses, o cualquier diferencia
                                            mencionados, han sido o serán cobrados correctamente por parte de
                                            <strong>GOLDBERGFUND</strong>.
                                        </p>
                                        <p>
                                            <strong>
                                                EL ACREDITADO deberá conservar las fichas de depósito o comprobantes de
                                                transferencia de los pagos que realice a
                                                GOLDBERGFUND, para el caso de que no se reflejen en la contabilidad de
                                                GOLDBERGFUND.
                                            </strong>
                                        </p>
                                        <p>
                                            <strong>SÉPTIMA. ‐</strong> Los pagos efectuados por <strong>EL
                                                ACREDITADO</strong> se aplicará en el siguiente orden: 1) impuestos, 2)
                                            intereses
                                            moratorios, 3) comisiones, 4) gastos, 5) intereses ordinarios y 6) capital
                                        </p>
                                        <p>
                                            <strong>OCTAVA. ‐ EL ACREDITADO</strong> se obliga a pagar a
                                            <strong>GOLDBERGFUND</strong> por el otorgamiento del crédito revolvente
                                            objeto del
                                            presente contrato y sin necesidad de previo requerimiento, por concepto de
                                            intereses ordinarios, la tasa de interés anual
                                            ordinaria establecida en la caratula (Anexo A) del presente contrato. Los
                                            intereses ordinarios se generarán desde la fecha
                                            de celebración del presente contrato y hasta el pago total del crédito
                                            otorgado.
                                        </p>
                                        <p>
                                            Los intereses ordinarios se calcularán con base a la siguiente fórmula.
                                        </p>
                                        <p>
                                            <strong>
                                                Tasa de interés anual / 360 = Tasa de interés diaria
                                                (Tasa de interés diaria * número de días efectivamente transcurridos) *
                                                Capital = Intereses Ordinarios.
                                            </strong>
                                        </p>
                                        <p>
                                            En caso de incumplimiento en el pago de las obligaciones en términos del
                                            presente contrato, EL ACREDITADO deberá pagar
                                            por concepto de intereses moratorios sobre saldo insoluto computables desde
                                            la fecha del incumplimiento y hasta el pago
                                            total del adeudo. El porcentaje de la tasa de interés moratoria es la que se
                                            establece en la carátula (Anexo A) del presente
                                            contrato.
                                        </p>
                                        <p>
                                            Los intereses moratorios se calcularán con base a la siguiente formula:
                                        </p>
                                    </div>
                                </div>
                            </slot>
                        </div>
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 5 -->
                <div class="paper-sheet">
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <div class="main-content">
                            <slot>
                                <div class="contract-page pdf-line-exception-b">
                                    <div class="contract-header">
                                        <div class="contract-number">
                                            Número de Contrato: <input type="text" class="underline-input visible-input"
                                                :value="store.formSaveCOAS.referenceNumber || ''" disabled />
                                        </div>
                                    </div>
                                    <div class="content-clausulas">
                                        <p>
                                            <strong>
                                                Tasa de interés anual moratoria fija / 360 = Tasa de interés diaria [%
                                                DIARIO].
                                                (Tasa de interés diaria * número de días efectivamente transcurridos)
                                                *Capital = Intereses Moratorios.
                                            </strong>
                                        </p>
                                        <p>
                                            En ningún caso los intereses moratorios serán exigidos por adelantado, sino
                                            únicamente por periodos vencidos
                                        </p>
                                        <p>
                                            <strong>NOVENA. ‐</strong> El presente contrato, con todas y cada una de sus
                                            obligaciones, surtirá sus efectos legales en la fecha de su
                                            firma y concluirá en la fecha en que <strong>EL ACREDITADO</strong> liquide,
                                            a entera satisfacción de <strong>GOLDBERGFUND</strong> el monto total de la
                                            cantidad adeudada que se señala en el estado de cuenta mensual, más los
                                            intereses ordinarios, intereses moratorios,
                                            seguros, comisiones y demás gastos generados por la celebración del presente
                                            contrato y sus Anexos.

                                        </p>
                                        <p>
                                            <strong>DÉCIMA. ‐ EL OBLIGADO SOLIDARIO</strong> que comparece a la
                                            celebración del presente contrato, se obliga solidaria e
                                            incondicionalmente a realizar el pago puntual y oportuno del capital,
                                            intereses ordinarios, intereses moratorios, seguros,
                                            comisiones y demás cantidades establecidas en el presente contrato. Por lo
                                            anterior, <strong>EL OBLIGADO SOLIDARIO</strong> deberá
                                            responder con todo su patrimonio presente o futuro, de las obligaciones de
                                            <strong>EL ACREDITADO</strong>.
                                        </p>
                                        <p>
                                            Como consecuencia de lo anterior, <strong>GOLDBERGFUND</strong> podrá
                                            realizar el cobro de manera directa a <strong>EL OBLIGADO SOLIDARIO</strong>
                                            del capital, intereses ordinarios, intereses moratorios, seguros, comisiones
                                            y demás cantidades establecidas en el presente
                                            contrato, así como en cualquiera de sus anexos, ya sea de manera total o
                                            parcial, sin realizar primeramente el cobro de
                                            dichas cantidades a <strong>EL ACREDITADO</strong>, ni agotar el cobro de
                                            las mismas en los bienes de <strong>EL ACREDITADO</strong>.
                                        </p>
                                        <p>
                                            Para efectos de lo establecido en esta cláusula, <strong>EL OBLIGADO
                                                SOLIDARIO</strong> renuncia expresamente a los beneficios de Orden,
                                            Excusión y División que establece el Código Civil Vigente en Quintana Roo y
                                            el Código Civil Federal.
                                        </p>
                                        <p>
                                            <strong>DÉCIMA PRIMERA. ‐ EL ACREDITADO</strong> y <strong>EL OBLIGADO
                                                SOLIDARIO</strong>, manifiestan su consentimiento en firmar como
                                            suscriptor y aval respectivamente, un título mercantil o Pagaré único por la
                                            cantidad total del crédito otorgado en el
                                            presente contrato, el cual incluirá el importe de la suerte principal, los
                                            intereses ordinarios, intereses moratorios,
                                            comisiones y seguros, a efecto de garantizar el cumplimiento de las
                                            obligaciones derivadas del presente contrato.
                                        </p>
                                        <p>
                                            Dicho Pagaré único formará parte integrante del presente contrato como Anexo
                                            “C” y quedará a disposición de
                                            <strong>GOLDBERGFUND</strong> y se devolverá conforme se acredite el pago
                                            total del crédito, mediante la entrega de las fichas de
                                            depósito o comprobantes de pago a que hace referencie el presente contrato.
                                        </p>
                                        <p>
                                            <strong>DÉCIMA SEGUNDA. ‐ EL ACREDITADO</strong> podrá liquidar
                                            anticipadamente el saldo de su crédito sin cargo o comisión, para lo
                                            cual deberá solicitarlo por escrito a <strong>GOLDBERGFUND</strong>. Una vez
                                            presentada la solicitud por parte de <strong>EL ACREDITADO</strong>,
                                            <strong>GOLDBERGFUND</strong> le proporcionará un número de folio que
                                            identifique su solicitud.
                                        </p>
                                        <p>
                                            <strong>DÉCIMA TERCERA. ‐ GOLDBERGFUND</strong> dará por terminado el
                                            contrato el día hábil siguiente a aquél en que reciban la
                                            solicitud de cancelación de la tarjeta adicional emitida y comercializada
                                            por American Express. En caso de existir adeudos
                                            pendientes, <strong>GOLDBERGFUND</strong> se compromete a informar el saldo
                                            de liquidación a <strong>EL ACREDITADO</strong> dentro de los siguientes
                                            dos días hábiles a su solicitud. Para la liquidación del crédito, <strong>EL
                                                ACREDITADO</strong> debe depositar el importe exacto en una sola
                                            exhibición en la cuenta proporcionada por <strong>GOLDBERGFUND</strong>; una
                                            vez realizado el pago, se dará por terminado el contrato
                                            y <strong>GOLDBERGFUND</strong> pondrá a disposición de <strong>EL
                                                ACREDITADO</strong> dentro de los treinta días hábiles siguientes al día
                                            del pago de
                                            la liquidación, la carta finiquito correspondiente.
                                            <strong>GOLDBERGFUND</strong> reportará a las sociedades de información
                                            crediticia que
                                            la cuenta está cerrada sin adeudo alguno en el reporte inmediato siguiente.
                                        </p>
                                        <p>
                                            En el supuesto de existir saldo a favor de <strong>EL ACREDITADO</strong>,
                                            este deberá realizar una compra por el monto exacto del saldo
                                            a favor, a fin de que <strong>GOLDBERGFUND</strong> esté en posibilidad de
                                            realizar la cancelación de la tarjeta.
                                        </p>
                                        <p>
                                            Cuando la terminación del contrato sea por conducto de una ENTIDAD
                                            FINANCIERA esta liquidará el adeudo de <strong>EL
                                                ACREDITADO</strong> de acuerdo con la información que proporcione
                                            <strong>GOLDBERGFUND</strong> y una vez cubiertos los adeudos a
                                            <strong>GOLDBERGFUND</strong> este renunciará a todos los derechos de cobro
                                            remanente que pudiera subsistir después del momento
                                            de la cancelación.
                                        </p>
                                        <p>
                                            <strong>EL ACREDITADO</strong> podrá efectuar, en cualquier tiempo, pagos
                                            anticipados en reembolso del crédito, los cuales se aplicarán
                                            al pago del saldo insoluto en orden inverso al del vencimiento de las
                                            amortizaciones respectivas, es decir, se aplicarán a las
                                        </p>
                                    </div>
                                </div>
                            </slot>
                        </div>
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 6 -->
                <div class="paper-sheet">
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <div class="main-content">
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number">
                                            Número de Contrato: <input type="text" class="underline-input"
                                                :value="store.formSaveCOAS.referenceNumber || ''" disabled />
                                        </div>
                                    </div>
                                    <div class="content-clausulas">
                                        <p>
                                            últimas amortizaciones/pagos que se vayan a vencer y tendrán efecto a partir
                                            del siguiente período al que se realicen,
                                            tomando en cuenta lo previsto en la cláusula séptima del presente contrato.
                                        </p>
                                        <p>
                                            <strong>GOLDBERGFUND</strong> calculará el importe de los intereses por
                                            devengar, con base en el nuevo saldo insoluto, <strong>GOLDBERGFUND</strong>
                                            y <strong>EL ACREDITADO</strong>, convienen en que los pagos anticipados
                                            reducirán exclusivamente el plazo de este contrato, por lo que
                                            no variarán el monto de cada una de las amortizaciones señaladas en el
                                            presente contrato y sus anexos. Con independencia
                                            de lo anterior, <strong>EL ACREDITADO</strong> podrá solicitar por escrito a
                                            <strong>GOLDBERGFUND</strong> que los pagos anticipados disminuyan el
                                            monto de las amortizaciones a su cargo sin que se modifique el plazo
                                            remanente del crédito, caso en el cual las
                                            amortizaciones variarán en términos de la nueva tabla de amortización que
                                            <strong>GOLDBERGFUND</strong> le proporcione a <strong>EL
                                                ACREDITADO</strong>. En cualquier caso, <strong>GOLDBERGFUND</strong>
                                            deberá calcular el importe de los intereses por devengar con base en el
                                            nuevo saldo insoluto y le hará entrega a <strong>EL ACREDITADO</strong> del
                                            comprobante correspondiente del pago anticipado.
                                        </p>
                                        <p>
                                            <strong>DÉCIMA CUARTA. ‐</strong> Las partes convienen expresamente que, si
                                            <strong>EL ACREDITADO</strong> dejare de cumplir con cualquiera de las
                                            obligaciones a su cargo derivadas de este contrato, y sin necesidad de
                                            declaración judicial previa, <strong>GOLDBERGFUND</strong> podrá
                                            dar por vencido anticipadamente el plazo para el pago de las obligaciones
                                            derivadas del presente contrato. En tal caso,
                                            será exigible el pago total del adeudo que se encuentre pendiente de
                                            vencimiento, incluyendo los intereses ordinarios,
                                            comisiones y demás accesorios.
                                        </p>
                                        <p>
                                            <strong>DÉCIMA QUINTA. ‐</strong> Serán causa de rescisión de este contrato,
                                            los siguientes:
                                        </p>
                                        <div class="list-declaration">
                                            <ol type="a" class="list-text custom-alpha">
                                                <li class="list-letter list-letter-normal">
                                                    En caso de que cualquiera de las declaraciones <strong>EL
                                                        ACREDITADO</strong> contenidas en este contrato, sus anexos y la
                                                    solicitud
                                                    de crédito sea o resulte ser falsa o incorrecta;
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    En caso de que cualquier dato o información de <strong>EL
                                                        ACREDITADO</strong> que sea entregada o hecha del conocimiento
                                                    de
                                                    <strong>GOLDBERGFUND</strong> sea o resulte ser falsa o incorrecta;
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    El incumplimiento de <strong>EL ACREDITADO</strong> a cualquiera de
                                                    las obligaciones de hacer o de no hacer consignadas a su cargo
                                                    en este contrato;
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    Si el importe otorgado fuera destinado a la consecución de cualquier
                                                    acto ilícito;
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    La falta de pago por parte de <strong>EL ACREDITADO</strong> de dos
                                                    o más parcialidades consecutivas.
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    Si en cualquier ocasión y por cualquier motivo, este Contrato y/o
                                                    uno o varios Pagarés dejaren estar en pleno vigor y efecto
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    Si cualquier evento o condición ocurriere que, según lo determine
                                                    <strong>GOLDBERGFUND</strong> de buena fe, tenga o sea capaz
                                                    de tener un efecto adverso en la condición financiera de <strong>EL
                                                        ACREDITADO</strong>, o en su capacidad de pagar el crédito o
                                                    para cumplir con las obligaciones de pago que derivan del presente
                                                    Contrato.
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    La muerte, insolvencia, o incapacidad sobrevenida del
                                                    <strong>OBLIGADO SOLIDARIO</strong>, en caso de que sea una persona
                                                    física;
                                                    o bien la fusión, escisión, cambio de control derivado de una
                                                    capitalización o transmisión de acciones o partes
                                                    sociales, insolvencia, inicio de un concurso mercantil, disolución y
                                                    liquidación, en este último caso si se trata de una
                                                    sociedad mercantil. Lo anterior en el entendido de que <strong>EL
                                                        ACREDITADO</strong> no haya obtenido la autorización de
                                                    <strong>GOLDBERGFUND</strong> respecto del reemplazo o sustitución
                                                    del <strong>OBLIGADO SOLIDARIO</strong> cuando se presente alguna de
                                                    las
                                                    circunstancias señaladas en el presente párrafo, dentro de los tres
                                                    días hábiles siguientes a su acaecimiento.
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    Si EL ACREDITADO no da el aviso correspondiente del cambio de
                                                    domicilio a que se refiere la Cláusula Vigésima
                                                    Tercera del presente contrato
                                                </li>
                                            </ol>
                                        </div>
                                        <p class="mt-3">
                                            Ante la actualización de cualquiera de las causas de incumplimiento antes
                                            señalada, <strong>EL ACREDITADO</strong> estará obligado a
                                            pagar a <strong>GOLDBERGFUND</strong> de manera inmediata el importe total
                                            del saldo reflejado a esa fecha en los registros de
                                            <strong>GOLDBERGFUND</strong>, que incluyen también los intereses ordinarios
                                            vencidos, intereses moratorios, así como cualquier otro
                                            concepto devengado contractual o legalmente, pago que deberá verificarse sin
                                            necesidad de presentación, requerimiento,
                                            protesto u otra notificación de cualquier clase a <strong>EL
                                                ACREDITADO</strong>, a todas las cuales renuncia expresamente por el
                                            presente
                                            instrumento.
                                        </p>
                                    </div>
                                </div>
                            </slot>
                        </div>
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 7 -->
                <div class="paper-sheet">
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <div class="main-content">
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number">
                                            Número de Contrato: <input type="text" class="underline-input"
                                                :value="store.formSaveCOAS.referenceNumber || ''" disabled />
                                        </div>
                                    </div>
                                    <div class="content-clausulas">
                                        <p>
                                            <strong>DÉCIMA SEXTA. ‐ EL ACREDITADO</strong> autoriza a
                                            <strong>GOLDBERGFUND</strong> a:
                                        </p>
                                        <div class="list-declaration">
                                            <ol type="a" class="list-text custom-alpha">
                                                <li class="list-letter list-letter-normal">
                                                    Proporcionar y recabar información sobre operaciones crediticias y
                                                    otras de naturaleza análoga que haya celebrado
                                                    con <strong>GOLDBERGFUND</strong> a las sociedades de información
                                                    crediticia, en términos de la autorización previamente
                                                    otorgada
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    Consultar su información en las Sociedades de Información Crediticia
                                                    en forma previa al otorgamiento del presente
                                                    contrato, autorización que se realizó mediante medios electrónicos.
                                                </li>
                                            </ol>
                                        </div>
                                        <p class="mt-2">
                                            <strong>DÉCIMA SÉPTIMA. ‐ EL ACREDITADO</strong> autorizó a
                                            <strong>GOLDBERGFUND</strong> para que:
                                        </p>
                                        <p>
                                            <strong>(i)</strong> solicite, consulte, obtenga y verifique, cuantas veces
                                            considere necesario cualquier información financiera y de historial
                                            crediticio de cualquier sociedad de información crediticia en términos de la
                                            Ley Para Regular a las Sociedades de
                                            Información Crediticia; <strong>(ii)</strong> recopile, procese, use y
                                            transfiera la información personal de <strong>EL ACREDITADO</strong> en
                                            Posesión de
                                            los Particulares de conformidad con los términos y condiciones previstos en
                                            el aviso de privacidad de <strong>GOLDBERGFUND</strong> que
                                            firmado por <strong>EL ACREDITADO</strong>, forma parte del presente
                                            contrato, mismo que se puso a su disposición y cuyo propósito es,
                                            recopilar, usar y almacenar la información personal, comercial, financiera y
                                            de historial crediticio de <strong>EL ACREDITADO</strong> con
                                            entidades nacionales e internacionales relacionadas con
                                            <strong>GOLDBERGFUND</strong> así como con prestadores de servicios,
                                            incluyendo pero sin limitar a las agencias de cobranza con la finalidad de
                                            cumplir las obligaciones de <strong>GOLDBERGFUND</strong> de
                                            conformidad con la LFPDPPP, del presente contrato.
                                            <strong>GOLDBERGFUND</strong> garantiza que la información personal de EL
                                            ACREDITADO será tratada de conformidad con los términos y condiciones
                                            previstos en el aviso de privacidad. EL
                                            ACREDITADO reconoce y acepta que <strong>GOLDBERGFUND</strong> tendrá el
                                            derecho para modificar el aviso de privacidad, según se
                                            prevé en dicho aviso. Adicionalmente, <strong>EL ACREDITADO</strong> declara
                                            que el contenido de dicho aviso de privacidad fue puesto a
                                            su disposición por <strong>GOLDBERGFUND</strong> con anterioridad a la fecha
                                            de firma del presente Contrato, por lo que <strong>EL ACREDITADO</strong>
                                            confirma y ratifica, por este medio, que otorgó su consentimiento expreso
                                            con la finalidad de que <strong>GOLDBERGFUND</strong> pueda,
                                            recopilar, usar, procesar y almacenar su información personal con
                                            anterioridad a la celebración del presente contrato de
                                            conformidad con la LFPDPPP. Asimismo, <strong>EL ACREDITADO</strong>
                                            reconoce que el aviso de privacidad cumple con lo previsto por
                                            el Artículo 16 de la LFPDPPP.
                                        </p>
                                        <p>
                                            <strong>DÉCIMA OCTAVA. ‐</strong> Cualquier modificación relacionada al
                                            presente contrato deberá realizarse por escrito, misma que
                                            deberá celebrarse en un plazo mínimo de 10 días hábiles anteriores a la
                                            fecha en que pretende surta sus efectos;
                                            requiriendo el consentimiento de ambas partes. La modificación a que hace
                                            referencia esta cláusula en ningún caso aplicará
                                            para las tasas de interés ni nuevas comisiones.
                                        </p>
                                        <p>
                                            Se entenderá que <strong>EL ACREDITADO</strong> otorga su consentimiento si
                                            en un plazo de 3 días hábiles posteriores a la notificación
                                            que le haga <strong>GOLDBERGFUND</strong>, no presenta inconformidad alguna
                                            por escrito dirigido a <strong>GOLDBERGFUND</strong>, y en su caso
                                            <strong>GOLDBERGFUND</strong> entregará un folio del número de
                                            inconformidad.
                                        </p>
                                        <p>
                                            <strong>DÉCIMA NOVENA. ‐</strong> Una vez concluido el presente contrato y
                                            pagada la totalidad de las compras realizadas, más los
                                            intereses, comisiones, seguros y gastos por parte de <strong>EL
                                                ACREDITADO</strong>, <strong>GOLDBERGFUND</strong> emitirá, dentro de
                                            los 30 (treinta)
                                            días hábiles siguientes a la verificación del pago del monto ejercido, la
                                            carta finiquito que establezca la inexistencia de
                                            adeudos por parte de <strong>EL ACREDITADO</strong>. A menos que se extienda
                                            dicha carta finiquito, no se entenderá que el presente
                                            contrato ha concluido, y que las obligaciones de pago a cargo de <strong>EL
                                                ACREDITADO</strong> han sido satisfechas. Será responsabilidad
                                            de <strong>EL ACREDITADO</strong>, o en su caso, de EL OBLIGADO SOLIDARIO
                                            solicitar y dar seguimiento con <strong>GOLDBERGFUND</strong> para la
                                            extensión de dicha carta finiquito.
                                        </p>
                                        <p>
                                            <strong>VIGÉSIMA. ‐ EL ACREDITADO</strong> autoriza expresamente a
                                            <strong>GOLDBERGFUND</strong> para:
                                        </p>
                                        <div class="list-declaration">
                                            <ol type="I">
                                                <li>
                                                    Solicitar, obtener o verificar cuantas veces sea necesario, su
                                                    información personal y capacidad de pago a través del
                                                    sistema de calificación que mide la capacidad de pago y
                                                    confiabilidad de las personas a través de su actividad en
                                                    las redes sociales;
                                                </li>
                                                <li>
                                                    Efectuar cualquier otra investigación.
                                                </li>
                                            </ol>
                                        </div>
                                        <p class="mt-3">
                                            <strong>VIGÉSIMA PRIMERA. ‐ El ACREDITADO</strong> contará con un período de
                                            90 (noventa) días naturales, contado a partir de la fecha
                                            que dio origen la reclamación y/o inconformidad, para formular, por escrito
                                            firmado, cualquier solicitud de aclaración de
                                            la información contenida en el mismo, ante el departamento de atención a
                                            clientes de <strong>GOLDBERGFUND</strong>. Cuyos datos de
                                        </p>
                                    </div>
                                </div>
                            </slot>
                        </div>
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 8 -->
                <div class="paper-sheet">
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <div class="main-content">
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number">
                                            Número de Contrato: <input type="text" class="underline-input" :value="store.formSaveCOAS.referenceNumber || ''" disabled />
                                        </div>
                                    </div>
                                    <div class="content-clausulas">
                                        <p>
                                            localización y contacto se establecen en la cláusula vigésima segunda. Una
                                            vez que <strong>GOLDBERGFUND</strong> reciba cualquier
                                            solicitud de aclaración que sea formulada por <strong>EL ACREDITADO</strong>
                                            conforme a lo establecido en este contrato, se tendrá un
                                            plazo de hasta 45 (cuarenta y cinco) días naturales para entregar a
                                            <strong>EL ACREDITADO</strong> el dictamen correspondiente, junto con
                                            la información y/o documentación considerada para su emisión, así como un
                                            informe detallado en el que se respondan los
                                            hechos contenidos en la solicitud de aclaración. En caso de que, conforme a
                                            dicho dictamen, resulte procedente el cobro
                                            del monto de que se trate, <strong>EL ACREDITADO</strong> deberá hacer el
                                            pago de la cantidad a su cargo, incluyendo los intereses
                                            ordinarios. Dentro del plazo de 15 (quince) días naturales contado a partir
                                            de la entrega del dictamen, <strong>GOLDBERGFUND</strong>
                                            pondrá a disposición de <strong>EL ACREDITADO</strong>, a través de su
                                            departamento de atención a clientes, el expediente generado por
                                            la solicitud, con la integración de la información y documentación que deba
                                            obrar en su poder y que se relacione
                                            directamente con la solicitud.
                                        </p>
                                        <p>
                                            <strong>VIGÉSIMA SEGUNDA. ‐</strong> Para efectos de consulta, información y
                                            quejas <strong>EL ACREDITADO</strong> podrá contactar a:
                                        </p>
                                        <div class="list-declaration">
                                            <ol type="a" class="list-text custom-alpha">
                                                <li class="list-letter list-letter-normal">
                                                    El departamento de atención de atención a clientes, con domicilio
                                                    en: Calle Robert Schumann, Número 4898, Colonia
                                                    Lomas del Seminario, Zapopan, Jalisco, C.P 45038 al teléfono 33 10
                                                    01 04 14 en un horario de atención de 9:00 a
                                                    18:30 horas, de lunes a viernes.
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    Calle 7 sur Lote 3, Manzana 29 Local 212 C.P. 77717, Colonia
                                                    Playacar Fase II, Playa del Carmen, Solidaridad, Quintana
                                                    Roo, en un horario de atención de 9:00 a 18:30 horas, de lunes a
                                                    viernes, o a través del correo electrónico
                                                    <a href="contacto@goldbergfund.com."
                                                        target="_blank"><u>contacto@goldbergfund.com.</u></a>
                                                </li>
                                            </ol>
                                        </div>
                                        <p class="mt-2">
                                            <strong>VIGÉSIMA TERCERA. ‐ GOLDBERGFUND</strong>, <strong>EL
                                                ACREDITADO</strong> y <strong>EL OBLIGADO SOLIDARIO</strong> acuerdan
                                            que, para todos los efectos
                                            legales que correspondan derivados de este contrato, todos los avisos y
                                            notificaciones que tuvieren que darse se deberán
                                            entregar por escrito cuando se requiera constancia de los mismos dirigidos a
                                            la contraparte, o bien enviados mediante
                                            carta por correo certificado o mediante servicios especializados de
                                            mensajería o fedatario público, en el domicilio
                                            respectivo y sean recibidos por la parte a quien hayan sido dirigidos, por
                                            alguno de sus empleados o por quien se encuentre
                                            en el domicilio.
                                        </p>
                                        <p>
                                            <strong>EL ACREDITADO y EL OBLIGADO SOLIDARIO</strong> señalan como su
                                            domicilio para los efectos de lo señalado en la carátula del
                                            presente contrato.
                                        </p>
                                        <p>
                                            <strong>GOLDBERGFUND</strong>, <strong>EL ACREDITADO</strong> y <strong>EL
                                                OBLIGADO SOLIDARIO</strong> acuerdan que en caso de que llegaren por
                                            cualquier motivo,
                                            a mudarse del domicilio que indicaron en este contrato, deberán hacérselo
                                            saber a la otra parte 15 (quince) días naturales
                                            previos a la fecha del cambio respectivo, de lo contrario, la notificación,
                                            aviso o pago que efectúe la contraparte, se
                                            entenderá legalmente hecha en el domicilio que se hubiese señalado en el
                                            presente contrato con la persona que se
                                            encuentre en el mismo.
                                        </p>
                                        <p>
                                            <strong>VIGÉSIMA CUARTA. ‐ El ACREDITADO</strong> no podrá ceder o
                                            transmitir cualquier derecho u obligación que, en términos del
                                            contrato, resulte a su favor o a su cargo sin la previa aprobación escrita
                                            de <strong>GOLDBERGFUND</strong>.
                                        </p>
                                        <p>
                                            <strong>EL ACREDITADO</strong> autoriza expresamente a
                                            <strong>GOLDBERGFUND</strong> para que éste último pueda, endosar, ceder,
                                            transmitir,
                                            descontar, transferir, negociar, afectar y/o gravar, en cualquier tiempo y,
                                            respectivamente, cualquier derecho que, en
                                            términos del contrato, resulte a favor de <strong>GOLDBERGFUND</strong> y/o
                                            los derechos de crédito contenidos en el contrato, ya sea en
                                            forma total o parcial. Lo establecido en el presente párrafo, aplicará, de
                                            igual forma, respecto a cualquier acreedor y/o
                                            causahabiente subsecuente.
                                        </p>
                                        <p>
                                            <strong>VIGÉSIMA QUINTA. ‐</strong> Las Partes acuerdan y reconocen los
                                            alcances y términos del presente contrato, y <strong>EL ACREDITADO</strong>,
                                            así
                                            como el <strong>OBLIGADO SOLIDARIO</strong> otorgan de forma indubitable e
                                            irrevocable su consentimiento.
                                        </p>
                                        <p>
                                            <strong>EL ACREDITADO</strong> y <strong>EL OBLIGADO SOLIDARIO</strong>
                                            manifiestan que es su voluntad obligarse con <strong>GOLDBERGFUND</strong>
                                            respecto del
                                            cumplimiento de todas y cada una de las obligaciones a cargo de <strong>EL
                                                ACREDITADO</strong>, de conformidad con los términos y
                                            condiciones del <strong>Contrato, Carátula y Anexos</strong>. Declarando
                                            bajo protesta de decir verdad que la información proporcionada
                                            a <strong>GOLDBERGFUND</strong>, en este contrato, carátula y anexos son
                                            verdaderos.
                                        </p>
                                        <p>
                                            <strong>VIGÉSIMA SEXTA. ‐ GOLDBERGFUND</strong>, <strong>EL
                                                ACREDITADO</strong> y <strong>EL OBLIGADO SOLIDARIO</strong> convienen
                                            que para el conocimiento de
                                        </p>
                                    </div>
                                </div>
                            </slot>
                        </div>
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 9 -->
                <div class="paper-sheet pdf-firma-page-exception">
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <div class="main-content">
                            <slot>
                                <div class="contract-page">
                                    <div class="content-continue-text">
                                        <div class="contract-header">
                                            <div class="contract-number">
                                                Número de Contrato: <input type="text" class="underline-input"
                                                    :value="store.formSaveCOAS.referenceNumber || ''" disabled />
                                            </div>
                                        </div>
                                        <div class="content-clausulas">
                                            <p>
                                                cualquier controversia que llegare a suscitarse con motivo de la
                                                interpretación o cumplimiento del presente contrato, se
                                                someten a lo estipulado en la Ley General de Títulos y Operaciones de
                                                Crédito, el Código de Comercio, y a la jurisdicción
                                                de los tribunales competentes de la ciudad de Cancún, Quintana Roo,
                                                renunciando expresamente al fuero o fueros que
                                                pudieran corresponderles en razón de sus domicilios o vecindades presentes,
                                                futuros o bien por cualquier otra causa.
                                            </p>
                                            <p>
                                                El presente contrato y cada uno sus anexos incluyendo la carátula, una vez
                                                leído por <strong>GOLDBERGFUND</strong>, <strong>EL ACREDITADO</strong>
                                                <strong> y EL OBLIGADO SOLIDARIO</strong>, enterados y estando de acuerdo de su
                                                contenido y alcance legal, lo firman en dos tantos
                                                (quedando un tanto y sus anexos en poder de cada una de las partes) en la
                                                ciudad de Cancún, Quintana Roo, el día <input type="date" class="underline-input" v-model="acknowledgedKnown" required />.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="content-firma">
                                        <div class="container-fluid">
                                            <div class="row separate-firma-top">
                                                <div class="col-4 square-firma">
                                                    <div class="row top-firma">
                                                        <div class="col-12">
                                                            GOLDBERGFUND
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="signature-line"></div>
                                                        </div>
                                                        <div class="col-12 line-firma-bottom">
                                                            <p class="mb-0">KVF GROUP, S.A. DE C.V.</p>
                                                            <p class="mt-0">Representante Legal.</p>
                                                        </div>
                                                    </div>
                                                    <div class="row bottom-firma">
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>RFC:</label>
                                                                <input type="text" class="form-control underline-input" />
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Tipo de Identificación:</label>
                                                                <input type="text" class="form-control underline-input" />
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group form-group-exception">
                                                                <label>Número de Identificación:</label>
                                                                <input type="text" class="form-control underline-input" />
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group form-group-exception">
                                                                <label>Domicilio:</label>
                                                                <input type="text" class="form-control underline-input" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-4 square-firma">
                                                    <div class="row top-firma">
                                                        <div class="col-12">
                                                            EL ACREDITADO
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="signature-line"></div>
                                                        </div>
                                                        <div class="col-12 line-firma-bottom">
                                                            <p>{{ store.form.signatures?.accredited?.name }}</p>
                                                        </div>
                                                    </div>
                                                    <div class="row bottom-firma" style="margin-top: 71px;">
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>RFC:</label>
                                                                <input type="text" class="form-control underline-input"
                                                                    :value="store.form.signatures?.accredited?.rfc || ''"
                                                                    disabled />
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Tipo de Identificación:</label>
                                                                <input type="text" class="form-control underline-input"
                                                                    :value="store.form.signatures?.accredited?.typeIdentification || ''"
                                                                    disabled />
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group form-group-exception">
                                                                <label>Número de Identificación:</label>
                                                                <input type="text" class="form-control underline-input"
                                                                    :value="store.form.signatures?.accredited?.numIdentification || ''"
                                                                    disabled />
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group form-group-exception">
                                                                <label>Domicilio:</label>
                                                                <input type="text" class="form-control underline-input"
                                                                    :value="store.form.signatures?.accredited?.address || ''"
                                                                    disabled />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-4 square-firma">
                                                    <!-- Regla de negocio: 
                                                     El obligado solidario aplica en los contratos que se señala que existirá un aval
                                                     Si el obligado solidario es persona física aparecerá el nombre de la persona 
                                                    -->
                                                    <div class="row top-firma">
                                                        <div class="col-12">
                                                            EL OBLIGADO SOLIDARIO
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="signature-line"></div>
                                                        </div>
                                                        <div class="col-12 line-firma-bottom">
                                                            <p>Nombre / Razón Social.</p>
                                                            <p>Representante Legal.</p>
                                                            <!-- <p>{{ store.form.signatures?.accredited?.name }}</p> -->
                                                        </div>
                                                    </div>
                                                    <div class="row bottom-firma" style="margin-top: 40px;">
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>RFC:</label>
                                                                <!-- <input type="text" class="form-control underline-input"
                                                                    :value="store.form.signatures?.accredited?.rfc || ''"
                                                                    disabled /> -->
                                                                <input type="text" class="form-control underline-input" disabled />
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Tipo de Identificación:</label>
                                                                <!-- <input type="text" class="form-control underline-input"
                                                                    :value="store.form.signatures?.accredited?.typeIdentification || ''"
                                                                    disabled /> -->
                                                                <input type="text" class="form-control underline-input" disabled />
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group form-group-exception">
                                                                <label>Número de Identificación:</label>
                                                                 <!-- <input type="text" class="form-control underline-input"
                                                                    :value="store.form.signatures?.accredited?.numIdentification || ''"
                                                                    disabled /> -->
                                                                <input type="text" class="form-control underline-input" disabled />
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group form-group-exception">
                                                                <label>Domicilio:</label>
                                                                <!-- <input type="text" class="form-control underline-input"
                                                                    :value="store.form.signatures?.accredited?.address || ''"
                                                                    disabled /> -->
                                                                <input type="text" class="form-control underline-input" disabled />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row separate-firma">
                                                <div class="col-5 square-firma">
                                                    <div class="row top-firma">
                                                        <div class="col-12">
                                                            TESTIGO
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="signature-line"></div>
                                                        </div>
                                                    </div>
                                                    <div class="row bottom-firma bottom-firma-testigo">
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Nombre:</label>
                                                                <input type="text" class="form-control underline-input"
                                                                    v-model="witness1.witnessName" />
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>RFC:</label>
                                                                <input type="text" class="form-control underline-input"
                                                                    v-model="witness1.witnessRFC" />
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Tipo de identificación:</label>
                                                                <input type="text" class="form-control underline-input"
                                                                    v-model="witness1.witnessTypeIdentification" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-5 square-firma">
                                                    <div class="row top-firma">
                                                        <div class="col-12">
                                                            TESTIGO
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="signature-line"></div>
                                                        </div>
                                                    </div>
                                                    <div class="row bottom-firma bottom-firma-testigo">
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Nombre:</label>
                                                                <input type="text" class="form-control underline-input"
                                                                    v-model="witness2.witnessName" />
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>RFC:</label>
                                                                <input type="text" class="form-control underline-input"
                                                                    v-model="witness2.witnessRFC" />
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Tipo de identificación:</label>
                                                                <input type="text" class="form-control underline-input"
                                                                    v-model="witness2.witnessTypeIdentification" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </slot>
                        </div>
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Botón de descarga -->
                <div class="form-actions">
                    <button class="download-btn">Descargar PDF</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance } from 'vue';
import { useContractStore } from '@/pinia/LoanApplications/Legal/useContractStore.module';

const store = useContractStore();
const contractContent = ref(null);
const nameFormPDF = "CONTRATO DE APERTURA DE CRÉDITO (TARJETA AMERICAN EXPRESS) - PERSONA FISICA";
const statusContract = 21; //"Activo"

// Acceder a la instancia de la app
const app = getCurrentInstance();

//#region control de fecha string
const filters = app?.appContext.config.globalProperties.$filters;
//#endregion control de fecha string

const acknowledgedReceived = computed({
    get: () => {
        if (!store.formSaveCOAS.acknowledgedReceived) return '';
        return filters?.formatDateForInput?.(store.formSaveCOAS.acknowledgedReceived) || store.formSaveCOAS.acknowledgedReceived;
    },
    set: () => { store.formSaveCOAS.acknowledgedReceived = ''; }
});

const acknowledgedKnown = computed({
    get: () => {
        if (!store.formSaveCOAS.acknowledgedKnown) return '';
        return filters?.formatDateForInput?.(store.formSaveCOAS.acknowledgedKnown) || store.formSaveCOAS.acknowledgedKnown;
    },
    set: (value) => { store.formSaveCOAS.acknowledgedKnown = value; }
});

// Computed para testigos (con inicialización segura)
const witness1 = computed({
    get: () => {
        if (!store.formSaveCOAS.witnesses) {
            store.formSaveCOAS.witnesses = [{}]; // Inicializa con un testigo vacío
        }
        return store.formSaveCOAS.witnesses[0] || {};
    },
    set: (value) => {
        if (!store.formSaveCOAS.witnesses) {
            store.formSaveCOAS.witnesses = [];
        }
        store.formSaveCOAS.witnesses[0] = value;
    }
});

const witness2 = computed({
    get: () => {
        if (!store.formSaveCOAS.witnesses?.[1]) {
            store.formSaveCOAS.witnesses[1] = {};
        }
        return store.formSaveCOAS.witnesses[1];
    },
    set: (value) => {
        store.formSaveCOAS.witnesses[1] = value;
    }
});

const handleSubmit = () => {
    store.formSaveCOAS = {
        ...store.formSaveCOAS,
        loanApplicationId: store.selectedApplication.id,
        statusId: statusContract,
        acknowledgedReceived: store.formSaveCOAS.acknowledgedReceived,
        acknowledgedKnown: store.formSaveCOAS.acknowledgedKnown
    }
    store.nameFilePDF = nameFormPDF;
    store.saveData();
};

onMounted(() => {
    store.setContractContent(contractContent.value);
});
</script>